import * as Sentry from "@sentry/react";

import { config } from "@/config";

export function initSentry() {
  // Only initialize on client-side
  if (typeof window === "undefined") {
    return;
  }

  if (!config.isDeployed) {
    return;
  }

  console.assert(config.sentry.dsn, "Sentry DSN is not configured");

  Sentry.init({
    dsn: config.sentry.dsn,
    environment: config.env,
    release: config.sentry.releaseVersion,

    integrations: [
      Sentry.replayIntegration({
        // maskAllText: true,
        // blockAllMedia: true,
        // Additional SDK configuration goes in here, for example:
        maskAllInputs: true,
      }),
      Sentry.replayCanvasIntegration(),
    ],
    denyUrls: [
      // Chrome extensions
      /extensions\//i,
      /^chrome:\/\//i,
      /chrome-extension:\/\//i,
    ],
    ignoreErrors: [
      /Can't find variable: EmptyRanges\b/, // JSC (Safari) — FLOWSTEP-FRONTEND-K25
      /\bEmptyRanges is not defined/, // V8 (Chrome/Edge) — FLOWSTEP-FRONTEND-K25
      // Hydration mismatches on the public site are browser-extension DOM
      // mutation (antifingerprint/translate/etc.), not first-party bugs —
      // verified no local repro with a clean browser. FLOWSTEP-FRONTEND-JVR
      /^Hydration Error$/i,
      /Hydration failed because/i,
      /There was an error while hydrating/i,
      /Text content does not match server-rendered HTML/i,
      // Ignore known CEF/WebView noise where non-Error objects are rejected.
      // Keep this narrow so unrelated unhandled rejections still surface.
      /^Non-Error promise rejection captured with value: Object Not Found Matching Id:\d+, MethodName:(?:simulateEvent|update), ParamCount:\d+$/,
    ],
    // Adjust this value in production, or use tracesSampler for greater control
    tracesSampleRate: 0.2,
    // in development and sample at a lower rate in production
    replaysSessionSampleRate: 0.1,
    // If the entire session is not sampled, use the below sample rate to sample
    // sessions when an error occurs.
    replaysOnErrorSampleRate: 1.0,
  });
}
